import { IAiInterviewInfo } from '@src/types';
import request from '@utils/request';

export interface IGetAllInterCodeItem {
  interCode: string;
  areaName: string;
}

export interface AICodingEvaluateInfo {
  questionTitle: string;
  questionDescription: string;
  // addTime: number;
  expireTime: number;
  status: number;
}

// 接口文档 http://papi.sankuai.com/index/#/papi/project/4c1a2a20-81da-4857-8226-1fb012e19b7a?apiId=9e85f893-0956-4813-9f88-e3994ad32b47
// 获取区号接口
export async function getAreaCode(): Promise<IGetAllInterCodeItem[]> {
  const res: IGetAllInterCodeItem[] = await request.post(`/api/official/mobile/user/phone/getAllInterCode`);
  return res;
}

interface IGetVerificationCode {
  requestCode: string; // yoda request_code
}
// 接口文档 http://papi.sankuai.com/index/#/papi/project/195fa07e-3250-496a-904f-d392c5d0ec81?apiId=35ec5468-6e34-4980-9076-7b87a7466793
// 获取yoda request_code接口
export async function getVerificationCode(params): Promise<IGetVerificationCode> {
  // 种上标识手机号登录的cookie
  document.cookie = 'unionLoginType=3;path=/;domain=meituan.com;max-age=43200;';
  const res: IGetVerificationCode = await request.post(
    `/api/official/mobile/user/sliding/verification/getCode`,
    params,
  );
  return res;
}
// export async function getVerificationCode(): Promise<IGetVerificationCode> {
//   const res: IGetVerificationCode = await request.post(
//     `/api/official/mobile/user/sliding/verification/getCode`,
//     undefined,
//     { isShowErrorDialog: false },
//   );
//   return res;
// }

interface IGetPhoneBindStatus {
  // # UN_BIND(1, "未绑定"),    BIND(2, "绑定");
  bindStatus: number;
}
// 查询微信登录手机号绑定情况
export async function getPhoneBindStatus(): Promise<IGetPhoneBindStatus> {
  // 切换到微信扫码登录时清除cookie
  document.cookie = 'unionLoginType=weixin;path=/;domain=meituan.com;max-age=43200;';
  const res: IGetPhoneBindStatus = await request.post(`/api/official/mobile/user/wechat/phone/bind/status`);
  return res;
}

// 微信登录绑定手机号
export async function bindPhone(params) {
  // 切换到微信扫码登录时清除cookie
  document.cookie = 'unionLoginType=weixin;path=/;domain=meituan.com;max-age=43200;';
  const res = await request.post(`/api/official/mobile/user/wechat/login/bind/phone`, params);
  return res;
}

// 校招修改bg映射
export async function getOuterBgCode(bgCode: string) {
  const res = await request.get(`/api/official/mobile/job/getOuterBgCode?bgCode=${bgCode}`);
  return res;
}

// 获取当前服务器时间
export async function getNowTime(): Promise<Number> {
  const res: Number = await request.post(`/api/official/mobile/getNowTime`);
  return res;
}

// 获取简历作品集下载链接
export async function getDownFileUrlApi(fileId: string, resumeUnionId: string): Promise<string> {
  const res: string = await request.get(
    `/api/official/mobile/resume/attachment/download?fileId=${fileId}&resumeUnionId=${resumeUnionId}`,
  );
  return res;
}

// AI-Coding 获取评测信息
export async function getAICodingEvaluateInfo(recordUnionId: string) {
  const res = await request.post<AICodingEvaluateInfo>(`/api/aicoding/query`, { recordUnionId });
  return res;
}

// AI-Coding 提交测评信息
export async function submitAICodingEvaluateInfo(params) {
  const res = await request.post<{
    success: boolean;
    errorCode: string;
  }>('/api/aicoding/submit', params);
  return res;
}

// AI-Coding 校验作品手机号
export async function validateAICodingPhone(params: { recordUnionId: string; workUrl: string }) {
  const res = await request.post('/api/aicoding/nocode/verify', params);
  return res;
}

// 获取AI面试考试信息
export async function getAiInterviewInfo(relationUnionId: string): Promise<IAiInterviewInfo> {
  const res: IAiInterviewInfo = await request.post('/api/official/assessment/aiInterview/info', {
    relationUnionId,
  });
  return res;
}
